import { Injectable } from '@angular/core';

@Injectable()
export class SettingsService {

	constructor() { }

	size = window.innerWidth
	liveURL = 'stunii.com'
	liveURLAPI = 'api.stunii.com'
	protocol = 'https://'

	localPortAPI = ':50117/'
	localPort = ':4200/'



	get apiURL(): string {
	//  let u = 'http://localhost' + this.localPortAPI

		if (window.location.host.indexOf(this.liveURL) !== -1) {
		let	u = this.protocol + this.liveURLAPI + '/'
		}

		 let u = 'https://api.stunii.com/'
	    //   let u = 'http://localhost'+this.localPortAPI
		return u
	}

	get bURL(): string {
		let u = 'http://localhost' + this.localPort
		if (window.location.host.indexOf(this.liveURL) !== -1) {
			u = this.protocol + this.liveURL + '/'
		}

		return u
	}

	truncate(string, length, delimiter): string {
		if (!string) return ''
		delimiter = delimiter || '...'
		return string.length > length ? string.substr(0, length) + delimiter : string
	}


	mailFormat(email): boolean {

		const EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i

		if (email != "" && (email.length <= 5 || !EMAIL_REGEXP.test(email))) {
			return false
		}

		return true
	}

	inArray(target, array): boolean {

		if (array != undefined ) {
			for(var i = 0; i < array.length; i++) {
				if(array[i] === target) {
					return true
				}
			}
			return false
		} else {
			return false
		}
	}

	findInArrObj(dataset, name, value) {
		//console.log(dataset, name, value)
		for (var i = 0; i < dataset.length; i++) {
			if (dataset[i][name] == value) {
				return i
			}
		}
		return -1
	}

	createRange(num, from) {
		var f = from ? from : 1
		var items: number[] = []
		
		for(var i = f; i <= num; i++){
			items.push(i)
		}

		if (f > 1) {
			return items.reverse()
		}

		return items
	}

	onResize(event) {
		this.size = event.target.innerWidth
	}

	setFocus(el) {
		el.setSelectionRange(0, el.value.length)
	}

	randomStr(): string {
		var text = ''
		var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

		for( var i = 0; i <= 8; i++ ) {
			text += possible.charAt(Math.floor(Math.random() * possible.length))
		}

		return text
	}







}



// WEBPACK FOOTER //
// D:/jordan/stunii-cms-stunii-cms-Appzorro1/stunii-cms-stunii-cms-Appzorro1/src/app/services/settings.service.ts